module.exports = __webpack_public_path__ + "static/media/DoorPaint_After.7f8dad1c.jpg";